/* Stylesheet */

.cohorts {
  padding: 0;
  color: var(--ion-color-text-tertiary);

  .label {
    margin: 0px 0px 12px 0px;
    font-size: 0.875rem;
    font-weight: 500;

    span {
      margin: 0px 0px 0px 4px;
      font-weight: normal;
      font-size: 0.75rem;
    }
  }

  .row {
    .col {
      padding: 0;
    }

    .cohort {
      display: flex;
      padding: 12px 0px 12px 0px;
      align-items: center;

      .flex_container {
        display: flex;
        align-items: center;
      }
    }
  }
}
